module.exports = __webpack_public_path__ + "img/green-tick.566a46cb.svg";